/**
 * Seasonal banner configuration for the homepage editorial banner.
 *
 * Each season has an editorial fashion image + matching quote and label,
 * automatically rotated based on the current month (Northern Hemisphere).
 *
 * To swap a photo: replace the `image` URL. To tweak a quote: edit the
 * `quote_nl` / `quote_en` / `quote_fr` strings.
 */

export const SEASONS = {
  winter: {
    label_nl: 'Winter editie',
    label_en: 'Winter edition',
    label_fr: 'Édition hiver',
    image:
      'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1920&q=80',
    quote_nl:
      '"Stijl is geen toeval. Het is een keuze — en wij maken die makkelijker."',
    quote_en:
      '"Style is never accidental. It is a choice — and we make it easier."',
    quote_fr:
      '« Le style n\u2019est jamais le fruit du hasard. C\u2019est un choix — et nous le rendons plus simple. »',
    image_position: 'object-center',
  },
  spring: {
    label_nl: 'Lente editie',
    label_en: 'Spring edition',
    label_fr: 'Édition printemps',
    image:
      'https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=1920&q=80',
    quote_nl:
      '"Een nieuw seizoen vraagt om een nieuwe blik — frisser, lichter, vol mogelijkheden."',
    quote_en:
      '"A new season calls for a new perspective — fresher, lighter, full of possibility."',
    quote_fr:
      '« Une nouvelle saison appelle un nouveau regard — plus frais, plus léger, riche de possibilités. »',
    image_position: 'object-center',
  },
  summer: {
    label_nl: 'Zomer editie',
    label_en: 'Summer edition',
    label_fr: 'Édition été',
    image:
      'https://customer-assets.emergentagent.com/job_lingua-assist-6/artifacts/693327qt_U%26fashionhomepage2.jpg',
    quote_nl:
      '"Licht, vrij en altijd met smaak — de zomer vraagt om je eigen stijl."',
    quote_en:
      '"Light, free and always in good taste — summer calls for your own style."',
    quote_fr:
      '« Léger, libre et toujours avec goût — l\u2019été appelle votre propre style. »',
    image_position: 'object-[50%_35%]',
  },
  autumn: {
    label_nl: 'Herfst editie',
    label_en: 'Autumn edition',
    label_fr: 'Édition automne',
    image:
      'https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=1920&q=80',
    quote_nl:
      '"Lagen, texturen en de warmte van een gekozen stijl."',
    quote_en:
      '"Layers, textures and the warmth of a chosen style."',
    quote_fr:
      '« Des couches, des textures et la chaleur d\u2019un style choisi. »',
    image_position: 'object-center',
  },
};

/**
 * Returns the current season key based on the Northern-Hemisphere calendar:
 *   Dec, Jan, Feb  → winter
 *   Mar, Apr, May  → spring
 *   Jun, Jul, Aug  → summer
 *   Sep, Oct, Nov  → autumn
 *
 * Optionally accepts a Date object (useful for testing).
 */
export function getCurrentSeason(now = new Date()) {
  const m = now.getMonth(); // 0-11
  if (m === 11 || m <= 1) return 'winter';
  if (m >= 2 && m <= 4) return 'spring';
  if (m >= 5 && m <= 7) return 'summer';
  return 'autumn';
}

export function getActiveBanner(now = new Date()) {
  return SEASONS[getCurrentSeason(now)];
}
